<template>
  <div
    id="changemodal"
    class="modal fade modal-top"
    tabindex="-1"
    role="dialog"
  >
    <validation-observer ref="formValidator">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header shadow">
            <h5 class="modal-title">
              <div class="modal-title-icon-container">
                <i class="fas fa-shield-check text-center"></i>
              </div>
              Cambio de Contraseña
            </h5>
          </div>

          <loading
            :width="100"
            :height="100"
            :active.sync="isLoading"
            loader="bars"
            :color="loadingColor"
            :background-color="loadingBackground"
            :is-full-page="false"
          />

          <form
            id="modal-cambiar-form"
            class="needs-validation"
            ref="form"
            @submit.prevent="handleSubmit"
            novalidate
          >
            <div class="modal-body px-0">
              <validation-provider
                name="(Contraseña actual)"
                rules="required"
                v-slot="{ errors, dirty }"
              >
                <custom-input
                  id="11111111"
                  class="mx-5 mx-5"
                  label="Contraseña actual *"
                  label-class="custom-modal-label"
                  required
                  type="password"
                  v-model="currentPassword"
                  :dirty="dirty"
                  :error="errors[0]"
                  :custom-error-msg="'Campo requerido'"
                  :can-modify-css="false"
                  icon="far fa-lock-alt"
                />
              </validation-provider>

              <div class="modal-info">
                <div class="row">
                  <div class="col-1 pt-1">
                    <i class="far fa-exclamation-circle"></i>
                  </div>
                  <div class="col-11">
                    <label>
                      El campo de contraseña no debe ser mayor de 8 caracteres
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1 pt-1">
                    <i class="far fa-exclamation-circle"></i>
                  </div>
                  <div class="col-11">
                    La contraseña debe incluir mínimo una letra mayúscula, un
                    símbolo y número
                  </div>
                </div>
              </div>

              <validation-provider
                name="(Nueva contraseña)"
                :rules="{
                  mustBeDifferentThanCPassword: currentPassword,
                  required: true,
                  hasSymbolsNumbersLowerCPassword: true,
                  hasCorrectSizeCPassword: true,
                }"
                v-slot="{ errors, dirty }"
              >
                <custom-input
                  id="2222222222"
                  class="mx-5"
                  label="Nueva contraseña *"
                  label-class="custom-modal-label"
                  required
                  type="password"
                  v-model="newPassword"
                  :error="errors[0]"
                  :dirty="dirty"
                  :custom-error-msg="'Campo requerido'"
                  icon="far fa-lock-alt"
                />
              </validation-provider>

              <validation-provider
                name="(Confirmar contraseña)"
                :rules="{ isEqualToCPassword: newPassword, required: true }"
                v-slot="{ errors, dirty }"
              >
                <custom-input
                  id="3333333"
                  class="mx-5 position-relative"
                  label="Confirmar contraseña *"
                  label-class="custom-modal-label"
                  required
                  type="password"
                  v-model="confirmPassword"
                  :dirty="dirty"
                  :error="errors[0]"
                  :custom-error-msg="'Campo requerido'"
                  icon="far fa-lock-alt"
                />
              </validation-provider>
            </div>
            <div class="row pb-4 px-5">
              <div class="col-6">
                <a
                  id="modal-cambiar-cancelar"
                  href
                  class="btn btn-block btn-outline-danger btn-cancel"
                  @click="handleCancel()"
                  data-dismiss="modal"
                >
                  Cancelar
                </a>
              </div>
              <div class="col-6">
                <button
                  id="modal-cambiar-guardar"
                  type="submit"
                  class="btn btn-block btn-success btn-save"
                >
                  Guardar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<style scoped></style>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { messages } from 'vee-validate/dist/locale/es.json'
import CustomInput from '@/components/common/form/CustomInput'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

Object.keys(rules).forEach((rule) => {
  let ruleObj = {
    ...rules[rule], // copies rule configuration
    message: messages[rule], // assign message
  }
  if (rule === 'min') {
    ruleObj.message = 'Demasiado corta'
  }
  extend(rule, ruleObj)
})

extend('hasSymbolsNumbersLowerCPassword', (value) => {
  let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z])/g
  if (value.search(regex) !== -1) return true
  return 'La contraseña debe incluir mínimo una letra mayúscula, un símbolo y número'
})

extend('hasCorrectSizeCPassword', (value) => {
  let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{3,8}$/g
  if (value.search(regex) !== -1) return true
  return 'Este campo no debe ser mayor de 8 caracteres'
})

extend('isEqualToCPassword', (value, args) => {
  if (args.length > 0) {
    if (value === args[0]) return true
  }
  return 'Esta contraseña debe ser igual a la entrada en el campo de nueva contraseña.'
})

extend('mustBeDifferentThanCPassword', (value, args) => {
  if (args.length > 0) {
    if (value !== args[0]) return true
  }
  return 'La contraseña nueva no puede ser igual a la anterior.'
})

export default {
  name: 'UserChangePassword',
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomInput,
    Loading,
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      isLoading: false,
      loadingColor: '#41b883',
      loadingBackground: '#ffffff',
    }
  },
  methods: {
    handleCancel() {
      let vm = this
      setTimeout(function() {
        vm.newPassword = ''
        vm.currentPassword = ''
        vm.confirmPassword = ''
        vm.$refs.formValidator.reset()
      }, 500)
    },
    async handleSubmit(e) {
      e.preventDefault()
      this.isLoading = true
      const isValid = await this.$refs.formValidator.validate()
      if (isValid) {
        let data = {
          username: this.$store.state.userProfile.name,
          currentPassword: this.currentPassword,
          confirmPassword: this.confirmPassword,
          newPassword: this.newPassword,
        }
        let vm = this

        this.$ApiPost('/api/account/changepassword', data)
          .then(function({ data: response }) {
            if (!response.error) {
              vm.$nextTick(() => {
                vm.$refs.modal.hide()
              })

              vm.$router.go('/dashboard')

              return
            } else {
              let cpErrors = {}
              cpErrors['(Contraseña actual)'] = [response.message]
              vm.$refs.formValidator.setErrors(cpErrors)
            }
          })
          .catch(function(errors) {
            vm.renameKeyErrors(errors.response.data.errors)
            vm.$refs.formValidator.setErrors(errors.response.data.errors)
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.isLoading = false
      }
    },
    renameKeyErrors(errors) {
      // eslint-disable-next-line no-prototype-builtins
      if (errors.hasOwnProperty('CurrentPassword')) {
        errors['(Contraseña actual)'] = errors.CurrentPassword
        delete errors['CurrentPassword']
      }

      // eslint-disable-next-line no-prototype-builtins
      if (errors.hasOwnProperty('NewPassword')) {
        errors['(Nueva contraseña)'] = errors.NewPassword
        delete errors['NewPassword']
      }

      // eslint-disable-next-line no-prototype-builtins
      if (errors.hasOwnProperty('ConfirmPassword')) {
        errors['(Confirmar contraseña)'] = errors.ConfirmPassword
        delete errors['ConfirmPassword']
      }
    },
  },
}
</script>

<style scoped>
.modal {
  margin-top: 2rem;
}

.modal-open .container-fluid,
.modal-open .container {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  -webkit-filter: blur(5px) grayscale(90%);
  -webkit-filter: blur(4px);
  -moz-filter: blur(4px);
  -o-filter: blur(4px);
  -ms-filter: blur(4px);
  filter: blur(4px);
  filter: require('../../../assets/img/blur.svg#blur');
  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='4');
}

.modal-dialog {
  width: 27rem;
  margin-top: 50px;
}

.modal-info {
  text-align: left;
  font: normal 14px/17px Lato !important;
  letter-spacing: 0;
  color: #3f5b60;
  opacity: 1;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  margin-top: 10px !important;
  padding: 1rem 2rem;
  margin-bottom: 10px;
}

.modal-info span {
  padding-bottom: 1rem !important;
  padding-top: 1rem !important;
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.modal-info i {
  padding-right: 0.5rem !important;
}

h5.modal-title {
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  font: Bold 25px/30px Lato;
  font-family: 'Lato', sans-serif;
  text-align: left;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
  margin-left: 2rem;
  padding-right: 1.5rem;
  padding-bottom: 0.4rem;
}

.modal-title-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.modal-title-icon-container i {
  color: #ff7058;
  opacity: 1;
  padding-bottom: -20px;
}

.modal-title-icon-container {
  border-radius: 50%;
  margin-right: 10px;
  min-width: 17px;
  min-height: 18px;
  padding-left: 1px;
  display: inline;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  left: 595px;
  top: 186px;
  height: 18px;
}

.modal-detail-nav {
  background: #f2f2f2 0% 0% no-repeat padding-box;
}

#modal-cambiar-form #modal-cambiar-cancelar {
  color: #c9545e;
  border-color: #c9545e;
  border-radius: 4px;
}

#modal-cambiar-form #modal-cambiar-cancelar:hover {
  color: #ffffff;
  border-color: #c9545e;
}

.btn-save {
  border: 1px solid;
}

.btn-cancel {
  border: 1px solid;
  font: 16px/29px Lato;
}

.modal-top {
  margin-top: 0rem;
}

#modal-cambiar-guardar {
  background-color: #2db782;
  border-radius: 4px;
  opacity: 1;
}

.custom-modal-label {
  font-family: 'Lato', sans-serif !important;
  color: #11291b !important;
  font-size: 16px !important;
  opacity: 1 !important;
}
</style>
